	<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Trámites</h4>
    <hr />

    <!-- Instrucciones -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert">
      <strong>Instrucciones:</strong>
      Escriba y presione <kbd>Enter</kbd> en los campos de texto.
      Seleccione una opción en las listas desplegables para filtrar automáticamente.
    </div>

<!-- Barra de acciones -->
<div class="row g-2 align-items-center mb-3">
  <div class="col-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
      @click.prevent="getDataPaginaTodos(1)" title="Recargar todos los registros">
      <span class="material-icons" style="font-size:16px">refresh</span> Todos
    </button>
  </div>
  <div class="col-auto ms-auto d-flex align-items-center gap-2" v-if="tramites.length > 0">
    <label class="form-label mb-0 small fw-bold">Mostrar</label>
    <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
      style="width:75px" @change="aplicarPaginacion(1)">
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
      <option :value="100">100</option>
    </select>
    <span class="small text-muted">registros</span>
  </div>
</div>

<!-- Tabla -->
<div class="table-responsive" v-if="tramites.length > 0">
  <table id="sampleTable" class="table table-hover table-bordered table-sm">
    <thead class="table-dark">
      <!-- Fila de encabezados -->
      <tr>
        <th class="th-sort" @click="ordenarPor('idTramite')">
          Número <span>{{ iconOrden('idTramite') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('inicial')">
          Inicial <span>{{ iconOrden('inicial') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('nombreComercial')">
          Prestador de salud <span>{{ iconOrden('nombreComercial') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('fechaDesde')">
          Fecha desde <span>{{ iconOrden('fechaDesde') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('fechaHasta')">
          Fecha hasta <span>{{ iconOrden('fechaHasta') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('servicioNombre')">
          Servicio <span>{{ iconOrden('servicioNombre') }}</span>
        </th>
        <th class="th-sort" @click="ordenarPor('estadoTramite')">
          Estado <span>{{ iconOrden('estadoTramite') }}</span>
        </th>
        <th>Opciones</th>
      </tr>
      <!-- Fila de filtros -->
      <tr>
        <th>
          <input v-model="filtroIdTramite" @input="aplicarPaginacion(1)"
            class="form-control form-control-sm" placeholder="Filtrar..." />
        </th>
        <th>
          <select v-model="filtroInicial" @change="aplicarPaginacion(1)" class="form-select form-select-sm">
            <option value="">Todos</option>
            <option value="1">Sí</option>
            <option value="0">No</option>
          </select>
        </th>
        <th>
          <input v-model="filtroPrestador" @input="aplicarPaginacion(1)"
            class="form-control form-control-sm" placeholder="Filtrar..." />
        </th>
        <th>
          <input type="date" v-model="filtroFechaDesde" @change="aplicarPaginacion(1)"
            class="form-control form-control-sm" />
        </th>
        <th>
          <input type="date" v-model="filtroFechaHasta" @change="aplicarPaginacion(1)"
            class="form-control form-control-sm" />
        </th>
        <th>
          <input v-model="filtroServicio" @input="aplicarPaginacion(1)"
            class="form-control form-control-sm" placeholder="Filtrar..." />
        </th>
        <th>
          <select v-model="filtroEstado" @change="aplicarPaginacion(1)"
            class="form-select form-select-sm">
            <option value="">Todos</option>
            <option value="ENVIADO">ENVIADO</option>
            <option value="RECIBIDO">RECIBIDO</option>
            <option value="EN PROCESO">EN PROCESO</option>
            <option value="OBSERVACIONES">OBSERVACIONES</option>
            <option value="FINALIZADO">FINALIZADO</option>
          </select>
        </th>
        <th></th>
      </tr>
    </thead>
        <tbody>
          <tr
            v-for="tramite in datosPaginados"
            :key="tramite.idTramite"
            @dblclick="handleRowClick($event, tramite.idTramite)"
            title="Doble clic para visualizar los detalles completos del registro"
          >
            <td>{{ tramite.idTramite }}</td>
            <td>
              <span v-if="tramite.inicial === 1" class="badge bg-success">Sí</span>
              <span v-else-if="tramite.inicial === 0" class="badge bg-secondary">No</span>
              <span v-else class="badge bg-warning text-dark">?</span>
            </td>
            <td>{{ tramite.nombreComercial }}</td>
            <td>{{ getFormattedDate(tramite.fechaDesde, 'DD/MM/YYYY') }}</td>
            <td>{{ getFormattedDate(tramite.fechaHasta, 'DD/MM/YYYY') }}</td>
            <td>{{ tramite.servicioNombre }}</td>
            <td>
              <span class="badge" :class="badgeEstado(tramite.estadoTramite)">
                {{ tramite.estadoTramite }}
              </span>
            </td>
            <td>
              <select class="form-select form-select-sm"
                @change="handleAction($event, tramite.idTramite, tramite.estadoTramite)">
                <option disabled selected>Seleccione...</option>
                <option value="resumen">Resumen</option>
                <option value="detalles">Detalles</option>
                <option value="recibir"
                  v-if="(idPerfil == 17 || idPerfil == 19) && tramite.estadoTramite === 'ENVIADO'">
                  Recibir
                </option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="8" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ tramitesOrdenados.length }} trámites
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="tramites.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ tramitesOrdenados.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }">
            <a class="page-link" href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Botón recibir todos -->
    <div class="d-flex justify-content-center mt-3">
<button @click="actualizarTodos"
  v-if="(idPerfil == 17 || idPerfil == 19) && filtroEstado === 'ENVIADO'"
  class="btn btn-success">
  Recibir todos los trámites
</button>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">info</span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
              data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">IdTramite</label></div>
                  <div class="col-10"><span>{{ datoTramite.idTramite }}</span></div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Fecha de registro</label></div>
                  <div class="col-10"><span>{{ getFormattedDate(datoTramite.fechaReg) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Prestador</label></div>
                  <div class="col-10"><span>{{ datoTramite.nombreComercial }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Servicio</label></div>
                  <div class="col-10"><span>{{ datoTramite.servicioNombre }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">FechaDesde</label></div>
                  <div class="col-10"><span>{{ getFormattedDate(datoTramite.fechaDesde) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">FechaHasta</label></div>
                  <div class="col-10"><span>{{ getFormattedDate(datoTramite.fechaHasta) }}</span></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                  <div class="col-10"><span>{{ datoTramite.descripcion }}</span></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import * as $ from "jquery";
import Swal from "sweetalert2";
window["$"] = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer },

data() {
  return {
    tramites:           [],
    datoTramite:        {},
    titulo:             "",
    btnEditar:          false,
    elementosPorPagina: 10,
    datosPaginados:     [],
    paginaActual:       1,
    modalWindow:        true,
    prestadors:         [],
    servicios:          [],
    periodos:           [],
    idUsuario:          0,
    idEmpresa:          0,
    idPerfil:           0,
    sinResultados:      false,
    // ── Ordenamiento ──────────────────────────────────
    campoOrden:         'idTramite',
    ascendente:         false,
    // ── Filtros de columna ─────────────────────────────
    filtroInicial:      '',
    filtroIdTramite:    '',
    filtroEstado:       '',
    filtroPrestador:    '',
    filtroServicio:     '',
    filtroFechaDesde:   '',
    filtroFechaHasta:   '',
  };
},

  computed: {
    // ── Trámites ordenados ─────────────────────────────────
tramitesOrdenados() {
  const campo = this.campoOrden;

  // ── Filtros de columna ─────────────────────────────
  let lista = this.tramites.filter(t => {
    const id  = this.filtroIdTramite ? String(t.idTramite ?? '').includes(this.filtroIdTramite)                                              : true;
    const est = this.filtroEstado    ? (t.estadoTramite ?? '') === this.filtroEstado                                                          : true;
    const pre = this.filtroPrestador ? String(t.nombreComercial ?? '').toLowerCase().includes(this.filtroPrestador.toLowerCase())             : true;
    const srv = this.filtroServicio  ? String(t.servicioNombre  ?? '').toLowerCase().includes(this.filtroServicio.toLowerCase())              : true;
    const fd  = this.filtroFechaDesde ? (t.fechaDesde ?? '').slice(0, 10) === this.filtroFechaDesde                                           : true;
    const fh  = this.filtroFechaHasta ? (t.fechaHasta ?? '').slice(0, 10) === this.filtroFechaHasta                                           : true;
    const ini = this.filtroInicial !== '' ? String(t.inicial) === this.filtroInicial : true;
	
    return id && est && pre && srv && fd && fh && ini;
  });

  // ── Ordenamiento ──────────────────────────────────
  return lista.sort((a, b) => {
    let va = a[campo] ?? '';
    let vb = b[campo] ?? '';
    if (campo === 'idTramite') {
      const na = parseInt(va, 10), nb = parseInt(vb, 10);
      if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
    }
    if (campo === 'inicial') {
      const ia = Number(va) || 0;
      const ib = Number(vb) || 0;
      return this.ascendente ? ia - ib : ib - ia;
    }
    if (campo === 'fechaDesde' || campo === 'fechaHasta') {
      const da = new Date(va), db = new Date(vb);
      if (!isNaN(da) && !isNaN(db)) return this.ascendente ? da - db : db - da;
    }
    const cmp = String(va).localeCompare(String(vb), 'es');
    return this.ascendente ? cmp : -cmp;
  });
},

    // ── Páginas visibles con puntos suspensivos ────────────
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];

      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');

      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },

mounted() {
  this.idUsuario = Number(window.sessionStorage.getItem("idUsuario"));
  this.idEmpresa = Number(window.sessionStorage.getItem("idEmpresa"));
  this.idPerfil  = Number(window.sessionStorage.getItem("idPerfil"));
  this.getDataPaginaTodos(this.paginaActual);
  this.$refs.layoutRef.toggleProcesos();
  this.$refs.layoutRef.toggleReportes();
  this.$refs.layoutRef.toggleParametros();
  this.$refs.layoutRef.toggleAyuda();
},

  methods: {
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },
    badgeEstado(estado) {
      return {
        'bg-secondary':       estado === 'ENVIADO',
        'bg-primary':         estado === 'RECIBIDO',
        'bg-warning text-dark': estado === 'EN PROCESO',
        'bg-info text-dark':  estado === 'OBSERVACIONES',
        'bg-success':         estado === 'FINALIZADO',
      };
    },

    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.tramitesOrdenados.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual  = noPagina;
      const ini          = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.tramitesOrdenados.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },

    // ── Carga de datos ─────────────────────────────────────

getDataPaginaTodos(noPagina) {
  this.resetFiltros();
  this.sinResultados = false;
  const endpoint = this.idPerfil === 22
    ? `/vwtramites/principal-obj/${this.idEmpresa}`
    : `/vwtramites/principal/${this.idEmpresa}`;

  api.get(endpoint)
    .then(response => {
      this.tramites = Array.isArray(response.data) ? response.data : [];
      this.aplicarPaginacion(noPagina);
      this.sinResultados = this.tramites.length === 0;
    });
},

resetFiltros() {
  this.filtroIdTramite  = '';
  this.filtroEstado     = '';
  this.filtroPrestador  = '';
  this.filtroServicio   = '';
  this.filtroFechaDesde = '';
  this.filtroFechaHasta = '';
},

    // ── Helpers ────────────────────────────────────────────
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },

    handleRowClick(event, idTramite) {
      if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') return;
      this.abrirEditar(idTramite);
    },

    handleAction(event, idTramite, estadoTramiteActual) {
      const action = event.target.value;
      if      (action === 'resumen')  this.abrirModalEditar(idTramite);
      else if (action === 'detalles') this.abrirEditar(idTramite);
      else if (action === 'recibir')  this.actualizarTramite(idTramite, estadoTramiteActual);
      event.target.value = 'Seleccione...';
    },

    abrirModalEditar(idTramite) {
      this.modalWindow = true;
      if (idTramite != null) {
        api.get("/vwtramites/" + idTramite).then(resp => { this.datoTramite = resp.data; });
      }
      $("#ventanaModal").modal("show");
      this.titulo    = "Resumen trámite " + idTramite;
      this.btnCrear  = false;
      this.btnEditar = true;
    },
    abrirEditar(idTramite) {
      if (idTramite != null) this.$router.push("/tramiteform/" + idTramite);
    },

    // ── Actualizar trámites ────────────────────────────────
    async actualizarTramite(idTramite, estadoTramiteActual) {
      try {
        const response = await api.put(`/tramites/recibir-tramite/${idTramite}`, null, {
          params: { idUsuario: this.idUsuario, estadoTramiteActual },
        });
        Swal.fire({ title: "Éxito", text: response.data, icon: "success", confirmButtonText: "OK" });
this.filtroEstado = "RECIBIDO";
this.aplicarPaginacion(1);
      } catch (error) {
        console.error("Error al actualizar el trámite:", error);
        Swal.fire({
          title: "Error",
          text: error.response?.data || "Error al actualizar el trámite",
          icon: "error", confirmButtonText: "Cerrar",
        });
      }
    },
    async actualizarTodos() {
      try {
        const response = await api.put(`/tramites/recibir-todos`, null, {
          params: { idUsuario: this.idUsuario },
        });
        Swal.fire({ title: "Éxito", html: response.data, icon: "success", confirmButtonText: "OK" });
this.filtroEstado = "RECIBIDO";
this.aplicarPaginacion(1);
      } catch (error) {
        console.error("Error al actualizar todos los trámites:", error);
        Swal.fire({
          title: "Error",
          text: error.response?.data || "Error al actualizar los trámites",
          icon: "error", confirmButtonText: "Cerrar",
        });
      }
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
</style>